export const OWNER_POST_MESSAGE = "BotXO";
export const POST_MESSAGE_MESSAGE_BOT = "message_bot";
export const POST_MESSAGE_MESSAGE_USER = "message_user";
export const POST_MESSAGE_GO_TO_MODULE = "go_to_module";
export const POST_MESSAGE_RESET_CHAT = "reset_chat";
export const POST_MESSAGE_CLEAR_CHAT = "clear_chat";
export const POST_MESSAGE_SEND_CVARS = "send_cvars";
export const POST_MESSAGE_SENT_FROM_SDK_BEFORE_DISPLAY =
  "sent_from_sdk_before_display";
export const POST_MESSAGE_SENT_FROM_SDK_BEFORE_SEND =
  "sent_from_sdk_before_send";
